import { create } from "zustand";
import { Tutorial } from "../api-objects/Tutorial";

interface TutorialState {
    tutorial: Tutorial | null;
}

interface TutorialStore {
    tutorialData: TutorialState;
    updateTutorial: (updates: Partial<TutorialState>) => void;
    clearTutorial: () => void;
}

// Zustand store
export const useTutorialStore = create<TutorialStore>((set) => {
    const storedData = localStorage.getItem("tutorialData");
    let parsedData: TutorialState = { tutorial: null };

    if (storedData) {
        try {
            parsedData = JSON.parse(storedData) as TutorialState;
        } catch (error) {
            console.error("Failed to parse tutorialData from localStorage:", error);
        }
    }

    return {
        tutorialData: parsedData,
        updateTutorial: (updates) => {
            set((state) => {
                const updatedTutorialData = { ...state.tutorialData, ...updates };
                localStorage.setItem("tutorialData", JSON.stringify(updatedTutorialData));
                return { tutorialData: updatedTutorialData };
            });
        },
        clearTutorial: () => {
            set({ tutorialData: { tutorial: null } });
            localStorage.removeItem("tutorialData");
        },
    };
});